<div class="editorText" [innerHTML]="parsedContent()"></div>
